import React from 'react';
import { Handshake } from '@mui/icons-material';
import { PageContainer, Content } from '../PageTemplate';
import Form from '../../components/form';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const GradientHero = styled.div`
  background: linear-gradient(
    150deg,
    #ff80b5 0%,
    #9089fc 20%,
    #ff80b5 40%,
    #40c9ff 60%,
    #a5fecb 80%,
    #9089fc 100%
  );
  background-size: 200% 200%;
  animation: gradientMove 15s ease infinite;
  padding: 16rem 2rem 8rem 2rem;
  margin-top: -80px;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;

  @keyframes gradientMove {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(
      circle at 50% 50%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%
    );
    filter: blur(60px);
    opacity: 0.6;
  }

  @media (max-width: 768px) {
    padding: 12rem 1rem 6rem 1rem;
    
    h1 {
      font-size: 2.5rem !important;
    }
    
    p {
      font-size: 1rem !important;
      padding: 0 1rem;
    }
  }
`;

const AgencyText = styled.div`
  text-align: center;
  max-width: 800px;
  margin: 0 auto 3rem auto;
  padding: 2rem;
  font-size: 1.25rem;
  line-height: 1.7;
  color: ${props => props.theme.colors.text};

  @media (max-width: 768px) {
    font-size: 1.1rem;
    padding: 1.5rem;
  }
`;

const PartnerProgram = () => {
  return (
    <PageContainer>
      <GradientHero>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Handshake sx={{ 
            fontSize: 64, 
            marginBottom: 2,
            filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))'
          }} />
          <motion.h1
            style={{
              fontSize: '3.5rem',
              marginBottom: '1.5rem',
              fontWeight: 700,
              position: 'relative',
              zIndex: 2
            }}
          >
            Partner Program
          </motion.h1>
          <motion.p
            style={{
              fontSize: '1.25rem',
              maxWidth: '800px',
              margin: '0 auto',
              opacity: 0.9,
              lineHeight: 1.6,
              position: 'relative',
              zIndex: 2
            }}
          >
            Join our partner network and grow with us
          </motion.p>
        </motion.div>
      </GradientHero>

      <Content>
        <AgencyText>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Are you an agency looking to sell ServTrackr? Join our partner program and earn competitive commissions while providing your clients with a powerful service business management solution. Our white-label options and dedicated partner support team are here to help you succeed.
          </motion.div>
        </AgencyText>

        <Form />
      </Content>
    </PageContainer>
  );
};

export default PartnerProgram;
